import * as angular from 'angular';
import { integrateUibModelInReact } from './confirm-modal.factory';

export interface TemplateModal {
    (templateUrl: string): angular.ui.bootstrap.IModalInstanceService;
}

function getTemplateModalInstance($uibModal): TemplateModal {
    return (
        templateUrl: string
    ): angular.ui.bootstrap.IModalInstanceService => {
        return $uibModal.open({
            templateUrl: templateUrl,
            controller: ($scope, $uibModalInstance) => {
                integrateUibModelInReact($scope, $uibModalInstance);
            }
        });
    };
}

angular.module('app').factory('templateModal', getTemplateModalInstance);
